import { register, registerWithUserID, trackEvent, trackPageView } from './internal/analytics';

/**
 * @deprecated This facade sends legacy Segment and Google Analytics data. Use the
 * purpose-specific Observability APIs and structured Journey context for new instrumentation.
 */
export const analytics = {
  register,
  registerWithUserID,
  /**
   * @deprecated This API sends legacy Segment analytics. Use `trackJourneyEvent` for
   * durable product behavior, `trackInternalEvent` for engineering diagnostics,
   * `trackError` for failures, or `markTiming` for durations.
   */
  // oxlint-disable-next-line typescript/no-deprecated -- OFFER-4581: existing legacy analytics usage is tracked for removal
  trackEvent,
  /**
   * @deprecated This API sends a legacy Segment page-view event. Use `trackJourneyEvent`
   * for durable product behavior or `trackInternalEvent` for an engineering diagnostic.
   */
  // oxlint-disable-next-line typescript/no-deprecated -- OFFER-4581: existing legacy analytics usage is tracked for removal
  trackPageView,
};
